import i18n from '@gik/i18n';
import { Button, SvgIcon } from '@gik/ui';
import React from 'react';
import coreTranslationKeys from '@gik/i18n/en/core';

type DisableSuggestionsButtonProps = {
  className: string;
  onClick();
};

export function DisableSuggestionsButton({ className, onClick }: DisableSuggestionsButtonProps) {
  return (
    <Button
      className={className}
      variant={'secondary-outline'}
      onClick={() => onClick()}
      append={<SvgIcon name="XCircle" />}
    >
      {i18n.t(coreTranslationKeys.core.disable)}
    </Button>
  );
}
